import React from "react";
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <a href="#" className="flex items-center gap-2.5" aria-label="Le Nouveau Placement — accueil" data-id="element-134" data-mp="3t0nzelv8fc7p">
      <span className={`flex h-8 w-8 items-center justify-center rounded-[10px] text-[15px] font-bold ${inverted ? "bg-canvas text-ink" : "bg-ink text-canvas"}`} aria-hidden="true" data-id="element-135" data-mp="3f99gef1brb0n">
        N
      </span>
      <span className={`whitespace-nowrap text-[17px] font-semibold tracking-tight ${inverted ? "text-canvas" : "text-ink"}`} data-id="element-136" data-mp="35ehfp2cg481n">
        Le Nouveau Placement
      </span>
    </a>;
}